import { createClient, getPatcher } from 'webdav';
import { generateRemoteUrl } from '@nextcloud/router';
import { getCurrentUser, getRequestToken } from '@nextcloud/auth';
import { request } from 'webdav/dist/node/request.js';
export const rootPath = `/files/${getCurrentUser()?.uid}`;
export const defaultRootUrl = generateRemoteUrl('dav' + rootPath);
export const getClient = (rootUrl = defaultRootUrl) => {
    const client = createClient(rootUrl, {
        headers: {
            requesttoken: getRequestToken() || '',
        },
    });
    /**
     * Allow to override the METHOD to support dav REPORT
     *
     * @see https://github.com/perry-mitchell/webdav-client/blob/8d9694613c978ce7404e26a401c39a41f125f87f/source/request.ts
     */
    const patcher = getPatcher();
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // https://github.com/perry-mitchell/hot-patcher/issues/6
    patcher.patch('request', (options) => {
        if (options.headers?.method) {
            options.method = options.headers.method;
            delete options.headers.method;
        }
        return request(options);
    });
    return client;
};
